export default "__VITE_ASSET__C9X_1P1l__"